import axios from 'axios';
import { postData } from '../axiosUtils';

const parkingService = {
  list: () => {
    return axios.get(`/api/parking/list`).then((response) => {
      return response.data;
    });
  },
  // get: (id: any) => {
  //   return axios.get(`/api/parking/details/${id}`).then((response) => {
  //     return response.data;
  //   });
  // },
  create: (entity: any) => {
    return postData({
      url: `/api/parking/create`,
      data: entity,
    }).then((response) => {
      return response;
    });
  },
  extend: (entity: any) => {
    return postData({
      url: `/api/parking/extend`,
      data: entity,
      method: 'PUT',
    }).then((response) => {
      return response;
    });
  },
  getParking: (entity: any) => {
    return postData({
      url: `/api/parking/getParking`,
      data: entity,
      method: 'PUT',
    }).then((response) => {
      return response;
    });
  },
  close: (entity: any) => {
    return postData({
      url: `/api/parking/close`,
      data: entity,
      method: 'PUT',
    }).then((response) => {
      return response;
    });
  },
  delete: (id: any) => {
    return postData({
      url: `/api/parking/delete/${id}`,
      method: 'DELETE',
    }).then((response) => {
      return response;
    });
  },
};

export default parkingService;
